export * from './math.js';
export * from './types.js';
export * from './movement.js';
export * from './ray.js';
export * from './weapons.js';
export * from './spread.js';

/** Fixed simulation timestep: 30 Hz. The whole stack agrees on this number. */
export const TICK_HZ = 30;
export const TICK_DT = 1 / TICK_HZ;
